import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowOutShare16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowOutShare16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.829 5.354a.5.5 0 0 1-.708 0L8.5 3.732v6.854a.5.5 0 0 1-1 0V3.733l-1.621 1.62a.5.5 0 1 1-.707-.706l2.475-2.475L8 1.818l.354.354 2.475 2.475a.5.5 0 0 1 0 .707M3 9a2 2 0 0 1 2-2h.375a.5.5 0 1 1 0 1H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-.375a.5.5 0 0 1 0-1H11a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowOutShare16);
